import React from 'react';
import PropTypes from 'prop-types';

import SecondaryNav from './footer/secondary_nav';
import social_logos from '../../../images/promo/social.png';

import monopoly_logo from './monopoly-logo.png';

import './style.scss';

const Footer = ({ footer }) => {
    return (
        <footer className="container-fluid">
            <div className="col-sm-8">
                <SecondaryNav footer={footer} />
                <div className="ten-x">
                    “10X” is a trademark of the Multi-State Lottery Association
                    and is used under license.
                </div>
                <div className="mono-logo">
                    <img src={monopoly_logo} alt="shows monopoly logo" />
                    <div className="disclaimer">
                        The MONOPOLY name and logo, the distinctive design of
                        the game board, the four corner squares, the MR.
                        MONOPOLY name and character, as well as each of the
                        distinctive elements of the board and playing pieces are
                        trademarks of Hasbro for its property trading game and
                        game equipment. © 1935, 2020 Hasbro. All Rights
                        Reserved. Licensed by Hasbro
                    </div>
                </div>
            </div>
            <div className="col-sm-4">
                <div className="social-links">
                    <img
                        src={social_logos}
                        alt="South Carolina Education Lottery"
                        className="img-responsive center-block"
                    />
                    <a
                        className="gr"
                        href="https://www.instagram.com/illinoislottery/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        &nbsp;
                    </a>
                    <a
                        className="fb"
                        href="https://www.facebook.com/illinoislottery/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        &nbsp;
                    </a>
                    <a
                        className="tw"
                        href="https://twitter.com/illinoislottery/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        &nbsp;
                    </a>
                    <a
                        className="yt"
                        href="https://www.youtube.com/user/TheIllinoisLottery"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        &nbsp;
                    </a>
                </div>
                <div className="responsibility">
                    Be Smart, Play Smart&trade; Must be 18 or older to play. If
                    you or someone you know has a gambling problem, crisis
                    counseling and referral services can be accessed by calling
                    1-800-GAMBLER (1-800-426- 2537). For additional info or to
                    exclude yourself, call 1-800-252-1775 or visit
                    illinoislottery.com.
                </div>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    footer: PropTypes.array.isRequired,
};

export default Footer;
